import React from "react";
import logo from "../../../src/assets/logo-white.svg"
 
export default function Header(){
    return (
      <header style={{ backgroundColor: '#103D4B' }} className="text-white px-6 py-4 flex justify-between items-center">
        <img src={logo} alt="Logo" className="h-10 w-auto" />
        <div className="text-lg font-medium text-right">
          Digital Certificate Verification System
        </div>
      </header>
    );
}